<template>
    <div class="pl-5 pt-2">
            <div class="iform-row mt-5">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group d-inline-flex w-100" data-testid="releaseDate">
                            <label class="input-label mr-3 w-25">Release Date</label>
                            <date-picker
                                id="release_date"
                                placeholder="Release Date"
                                class="w-25"
                                name="releaseNote[release_date]"
                                :config="datepickerConfig()"
                                :error="errorsList['releaseNote.release_date'] ? errorsList['releaseNote.release_date'][0] : ''"
                                v-model="releaseData.release_date"
                            ></date-picker>
                            <input
                                v-if="isEditing"
                                :value="releaseData.id"
                                type="hidden"
                                name="releaseNote[id]"
                            />
                        </div>
                    </div>
                </div>
                 <div class="row">
                    <div class="col-12">
                        <div class="form-group d-inline-flex w-100">
                            <label class="input-label mr-3 w-25">Release Title</label>
                            <app-input
                                data-testid="releaseTitle"
                                id="title"
                                name="releaseNote[title]"
                                placeholder="Release title"
                                class="w-50"
                                :is-required="true"
                                :value="getAttributeByName('title')"
                                :error="errorsList['releaseNote.title'] ? errorsList['releaseNote.title'][0] : ''"
                            ></app-input>
                            <app-checkbox
                                data-testid="status"
                                id="status"
                                name="releaseNote[status]"
                                label="Active"
                                class="w-25 pl-4"
                                :init-state="isEditing ? releaseData.status : true"
                            />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group d-inline-flex w-100">
                            <label class="input-label mr-3 w-25">Release Description</label>
                            <div class="w-75 d-flex flex-column">
                                <text-editor
                                    data-testid="description"
                                    id="description"
                                    name="releaseNote[description]"
                                    placeholder="Release description"
                                    rows="5"
                                    class="w-100"
                                    :value="getAttributeByName('description')"
                                ></text-editor>
                                <help-block
                                    class="text-danger"
                                    :text="errorsList['releaseNote.description'] ? errorsList['releaseNote.description'][0] : ''"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group d-inline-flex w-100">
                            <label class="input-label mr-3 w-25">Release Media File (max: 1Mb)</label>
                            <div class="w-75 d-flex">
                                <div class="w-50">
                                <input
                                    data-testid="media"
                                    id="media"
                                    ref="mediafile"
                                    name="releaseNote[media]"
                                    class="w-100"
                                    type="file"
                                    @change="handleFileInput($event)"
                                >
                                <help-block class="file-input-error"
                                            :text="errorsList['releaseNote.media'] ? errorsList['releaseNote.media'][0] : ''"/>
                                    <div v-if="releaseData.media && releaseData.id" class="mt-2">
                                        <app-button :link="route('platform-menu.release-notes.image', releaseData.id)" link-method="DELETE" type="error">
                                        <ion-icon name="trash-outline"></ion-icon>
                                        Delete
                                        </app-button>
                                    </div>
                                </div>

                                <div data-testid="imagePreview" class="w-50 d-table image-preview">
                                        <video v-if="isVideo(releaseData.media)"
                                        class="img-fluid h-100 rounded"
                                        :src="mediaFile || releaseFileUrl" autoplay loop></video>
                                        <img
                                            v-else
                                            :src="mediaFile || releaseFileUrl"
                                            class="img-fluid h-100 rounded"
                                        >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export const VIDEO_FILE_TYPES = ['mp4'];

export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: String,
            default: ''
        },
        oldValues: {
            type: String,
            default: ''
        },
        note: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            releaseData: [],
            releaseFileUrl: '',
            oldInputValuesList: {},
            releaseDate: new Date(),
        };
    },

    created() {
        this.setOldInputValuesList();
        this.setExistingNoteInfo();
    },

    methods: {
        setOldInputValuesList() {
            let noteOldValues = JSON.parse(this.oldValues);
            if (noteOldValues) {
                return this.oldInputValuesList = noteOldValues;
            }
        },

        setExistingNoteInfo() {
            let existingNote  = JSON.parse(this.note);
            if (existingNote) {
                return this.releaseData = existingNote;
            }
        },

        getAttributeByName(attribute) {
            if(Object.keys(this.oldInputValuesList).length > 0){
                return this.oldInputValuesList[attribute];
            } else if(this.releaseData[attribute]) {
                return this.releaseData[attribute];
            } else {
                return '';
            }
        },

        datepickerConfig() {
            return {
                enableTime: false,
                altFormat: 'm/j/Y',
                dateFormat: 'Y-m-d',
            };
        },

        isVideo(filename){
            if(filename) {
                let fileExtension = filename.split('.').pop();
                return VIDEO_FILE_TYPES.includes(fileExtension);
            }
            return false;
        },

        handleFileInput(e) {
            let self = this;
            let inputfile = e.target.files[0];

            let maxFileSize = 1048576; //1mB in bytes, the same set on BE

            if(inputfile.size > maxFileSize) {
                this.handleTooLargeFile(inputfile.size, maxFileSize);
                return;
            }

            let reader = new FileReader();
            reader.onload = function(event) {
                let fileUrl = event.target.result;

                self.releaseData.media_path = fileUrl;
                self.releaseFileUrl = fileUrl;
                self.releaseData.media = inputfile.name;
                self.clearFileError();
            };

            reader.readAsDataURL(inputfile);
        },

        handleTooLargeFile(fileSize, maxSize) {
            this.$refs['mediafile'].value = null;
            this.releaseFileUrl = '';

            alert('This file is too large. The file size is '
                + (fileSize/1024/1024).toFixed(2) + ' Mb. Maximum allowed size is '
                + maxSize/1024/1024 + ' Mb.');
        },

        clearFileError() {
            delete this.errorsList['releaseNote.media'];
        }
    },

    computed: {
        errorsList() {
            if (this.validationErrors.length > 0) {
                return JSON.parse(this.validationErrors);
            }
            return new Object();
        },

        mediaFile() {
            return this.releaseData.media ? this.releaseData.media_url : null;
        }
    },
};
</script>

<style scoped lang="scss">
.input-label {
    width: 30%;
}

.file-input-error {
    color: #dc3545;
    margin-top: 2rem;
}

.image-preview {
    z-index: 1;
}

</style>
